
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ILookupService, IStatusCode, LookupCriteria } from "@tylertech/tyler-api-types";

/**
 * ItemStatusLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ItemStatusLookupService {
    private readonly $apiService = inject(ApiService);
    
    Lookup(pCriteria: LookupCriteria): Promise<IStatusCode[]> {
        return this.$apiService.sendAuth("IItemStatusLookupService/Lookup", pCriteria);
    }
}
